const state = {
    backPage: undefined,
    callNumber : 0,
};

export default state;
